import {ssrLazy} from 'ssr/lazy';

export const GoBackLazy = ssrLazy(() => import(/* webpackChunkName: "goBack" */ '.'));
